<template>
    <div>

      <Breadtabsheader/>

        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2"style="margin-left:20px">
                                    <h1>线索转项目</h1>
                                </div>
                                <div class="h-pieceCon2">
                                    <div class="h-formLine weekplandetail35">
                                        <el-form :model="project" :rules="rules" ref="addForm" label-position="right" :inline="true" label-width="130"
                                                 class="demo-ruleForm h-formbLine h-formbLine1">

                                            <el-form-item class="h-elformWrap-1"  label="需求名称"  prop='projectName'>
                                                <el-input v-model="project.projectName" :disabled="true" ></el-input>
                                            </el-form-item>

                                            <el-form-item label="需求分类"  prop='clueType'   class="h-elformWrap-2 "  >
                                                <el-select v-model="project.clueType" :disabled="canSelectType"  @change="changeClueType">
                                                    <el-option label="货物类" value="货物类"></el-option>
                                                    <el-option label="工程类" value="工程类"></el-option>
                                                </el-select>
                                            </el-form-item>

                                            <el-form-item  label="线索来源" prop='cluefrom'  class="h-elformWrap-2">
                                                <el-input v-model="project.clueFromName"  disabled ></el-input>
                                            </el-form-item>

                                            <el-form-item label="渠道"  prop='customerChannel'  class="h-elformWrap-2">
                                                <brselect category="sales_region" :v="project.customerChannel" v-model="project.customerChannel"  disabled />
                                            </el-form-item>

                                            <el-form-item  label="小组长" prop='projectLeaderName'
                                                           class="h-elformWrap-2" placeholder="请输入小组长姓名" v-if="this.xmOrhw=='xm'">

                                                 <el-select v-model="project.projectLeaderCode" remote
                                                               filterable :filter-method="getUser"   clearable filterable placeholder="请输入小组长姓名"
                                                               :remote-method="getUser"  @change="setUser">
                                                    <el-option v-for="item in groupLeader"
                                                               :key="item.usercode"
                                                               :label="`${item.username} ${item.usercode}`"
                                                               :value="item.usercode">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>

                                            <div class="red-border-wrapper" v-if="this.xmOrhw=='hw'">

                                                <el-form-item  label="产品大类" prop='proLevelOne'  class="h-elformWrap-2" >
                                                        <template #label>
                                                            <span class="required-star">产品大类</span>
                                                        </template>
                                                        <el-select v-model="project.products[0].proLevelOne"
                                                                   style="width: 100%;"
                                                                   placeholder="--请选择产品大类--" clearable @change="selectTwo">
                                                            <el-option v-for="item in oneList"
                                                                       :key="item.id"
                                                                       :label="item.levelname"
                                                                       :value="item.levelname">
                                                            </el-option>
                                                        </el-select>
                                                </el-form-item>
                                                <el-form-item label="产品中类" prop='proLevelTwo'  class="h-elformWrap-2" >
                                                    <el-select v-model="project.products[0].proLevelTwo"
                                                               style="width: 100%;"
                                                               placeholder="--请选择产品中类--" clearable>
                                                        <el-option v-for="item in twoList"
                                                                   :key="item.id"
                                                                   :label="item.levelname"
                                                                   :value="item.levelname">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item  label="产品型号" prop='proModel'  class="h-elformWrap-2" >

                                                    <el-select v-model="project.products[0].proModel" style="width: 100%;" placeholder="--请选择产品型号--" filterable clearable allow-create
                                                               @change="selectLevelByModel(project.products[0].proModel)">
                                                        <el-option
                                                            v-for="item in productList"
                                                            :key="item.id"
                                                            :label="item.levelname"
                                                            :value="item.levelname">
                                                        </el-option>
                                                    </el-select>

                                                </el-form-item>

                                                <el-form-item  class="h-elformWrap-1">
                                                    <span style="color: red;	margin-left: 1rem;">注：以上三个选项只是填写一个</span>
                                                </el-form-item>

                                            </div>


                                            <el-form-item label="经销商名称"class="h-elformWrap-2"  prop="agentName">
                                                <el-select v-model="project.agentName" remote filterable clearable :disabled="isDls"
                                                           placeholder="请输入"
                                                           :remote-method="showComList" @change="showComList" >
                                                    <el-option v-for="(item) in agentList"
                                                               :key="item.customerName1"
                                                               :label="item.customerName1"
                                                               :value="item.customerName1">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>

                                            <el-form-item  label="预估金额" prop='estimatedAmount'  class="h-elformWrap-2">
                                                <el-input v-model="project.estimatedAmount"  ></el-input>
                                            </el-form-item>



                                            <el-form-item  label="战区" prop='areaName'  class="h-elformWrap-2"><!--战区-->

                                                <brselect category="show_area" :v="project.areaName" v-model="project.areaName" disabled
                                                          :clearable="true"
                                                          style="width:100%"/>

                                            </el-form-item>
                                            <el-form-item  label="省" prop='province'  class="h-elformWrap-2">
                                                <el-input v-model="project.province" disabled ></el-input>
                                            </el-form-item>
                                            <el-form-item  label="市" prop='city'  class="h-elformWrap-2">
                                                <el-input v-model="project.city" disabled ></el-input>
                                            </el-form-item>


                                            <el-form-item class="h-elformWrap-2" label="用户单位" prop="customerName">
                                                <el-select v-model="project.customerName" remote filterable   :clearable="true"
                                                           placeholder="请输入" disabled
                                                           :remote-method="showGroupClueList"  >
                                                    <el-option v-for="(item,index) in customerNameList"
                                                               :key="index"
                                                               :label="item.deptName"
                                                               :value="item.deptName">
                                                    </el-option>
                                                </el-select>

                                            </el-form-item>



                                            <el-form-item label="机会分类" prop='chanceTypeName'  class="h-elformWrap-2">
                                                <el-input v-model="project.chanceTypeName" disabled ></el-input>
                                            </el-form-item>

                                            <el-form-item label="部门/科室" prop='deptName'  class="h-elformWrap-2">
                                                <el-input v-model.trim="project.deptName" placeholder="请输入"/>
                                            </el-form-item>
                                            <el-form-item label="负责人" prop='chargePerson'  class="h-elformWrap-2">
                                                <el-input v-model.trim="project.chargePerson" placeholder="请输入"/>
                                            </el-form-item>
                                            <el-form-item label="电话" prop='phone'  class="h-elformWrap-2">
                                                <el-input v-model.trim="project.phone" placeholder="请输入"/>
                                            </el-form-item>

                                        </el-form>
                                    </div>
                                </div>
                            </div>


                            <div class="h-pieceTitle2 hang">
                                <div  class="h-txtCenter" style="margin-top: 0.3rem;">
                                    <el-button class="h-btn h-bBtn h-bgwhite" @click="backL">返回</el-button>
                                    <el-button  v-if="project.trackStatus=='1'" class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">提交转项目</el-button>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>



        </div>


  </div>
</template>


<script>
import ss from "../../../api/SystemService";
import BscClueManage from "@/api/guanhuai/BscClueManage";
export default {
    data() {
        return {

            fromSource:'',
            productList:[],
            oneList:[],
            twoList:[],
            listqd:[],
            agentList: [],      //签约经销商
            customerNameList: [], //用户单位list
            xmOrhw:'',//项目类货物类
            isDls:false,
            canSelectType:false,


            groupLeader:[],//小组长

            project:{
                clueid:'',
                projectLeaderCode:'',//项目负责人 +
                projectLeaderName:'',//项目负责人 +
                products: [{
                    proLevelOne:'', //产品大类
                    proLevelTwo:'',//产品中类
                    proLevelThree:'',//产品三级
                    proLevelFour:'',//产品四级
                    proModel:'',//产品型号
                    proCode:'',//产品编码
                }],

                cluefrom:'',//线索来源
                clueFromName:'',//线索来源名称
                agentName:'',//经销商名称
                agentCode:'',//经销商编号
                dueDate:'',//到期日时间   +
                areaName:'',//地区名称(战区)
                province:'',//省份
                city:'',// 城市
                customerChannel:'',//渠道
                customerName:'',//用户单位
                customerCode:'',//用户单位编码
                projectName:'',//需求名称  项目名+关键字
                probjectSorts:'',//需求分类(项目分类) 项目类=项目 货品类=散单
                chanceType:'',//机会分类
                clueType:'',//需求分类
                deptName:'',//科室/部门
                chargePerson:'',//联系人
                phone:'',//电话

                fromSource:'',
                trackStatus:'',
                estimatedAmount:''
            },
            rules: {

                projectLeaderName: [
                    { required: true, message: '小组长不能为空', trigger: 'change' }
                ],
                clueType: [
                    { required: true, message: '请选择需求分类', trigger: 'change' }
                ],



            },

        }

    },
    created() {
        //渠道漏斗渠道
        this.listqd=this.$store.getters.dictlist('sales_region');
        this.selectOne();//查询一级分类
        this.fromSource = this.$route.query.fromSource;

        this.getById(this.$route.query.id);
    },
    methods:{

        getById(id) {
            //如果是400来源
            if(this.fromSource=="MC_03_400"){
                ss.BscClueManage.getById(id).then(rd => {
                    if(rd.f){
                        this.setData(rd);
                    }else{
                        this.$msg.msge(rd.msg)
                    }

                })
            }else{
                ss.BscClueZhaoBiao.selectById(id).then(rd => {
                    if(rd.f){
                        this.setData(rd);
                    }else{
                        this.$msg.msge(rd.msg)
                    }
                })
            }

        },

        setData(rd){

            this.project.fromSource = rd.obj.fromSource;
            this.project.trackStatus =rd.obj.trackStatus;
            this.project.clueid = rd.obj.id;
            this.project.cluefrom = rd.obj.clueFrom;
            this.project.clueFromName = rd.obj.clueFromName;
            this.project.customerCode = rd.obj.userUnitCode;//用户单位编码
            this.project.customerName = rd.obj.userUnitName;//用户单位

            if(this.fromSource=="MC_03_400"){
                this.project.areaName = rd.obj.areaName;//地区名称(战区)
            }else{
                this.project.areaName = rd.obj.bigArea;//地区名称(战区)
            }

            this.project.province = rd.obj.province;//省份
            this.project.city = rd.obj.city;// 城市
            this.project.clueType = rd.obj.clueType;//需求分类

            //如果编码大于8位认为是经销商
            if(rd.obj.salesManCode.length>8){
                this.project.agentName = rd.obj.salesManName;//经销商名称
                this.project.agentCode = rd.obj.salesManCode;//经销商编号
                this.isDls = true;
            }


            //需求分类目前暂定 后面可能统一
            if(rd.obj.clueType!=null && rd.obj.clueType=='货物类'){
              //  this.project.probjectSorts ='sd';
                this.xmOrhw = 'hw';
            }

            if(rd.obj.clueType!=null && (rd.obj.clueType.indexOf("工程类") != -1 || rd.obj.clueType.indexOf('项目类') != -1)){
               // this.project.probjectSorts ='xm';
                this.project.clueType ='工程类';
                this.xmOrhw = 'xm';
            }
            //如果clueType有值 不允许手动选择需求分类
            if(rd.obj.clueType!=null && rd.obj.clueType!=''){
                this.canSelectType = true;
            }
            this.project.chanceType = "xinxibaobei";// 机会分类 默认信息报备
            this.project.chanceTypeName = "信息报备";// 机会分类 默认信息报备

            //获取对应渠道编码（线索与漏斗渠道字典不一样）
            this.listqd.forEach(element => {
                if(element.name.indexOf(rd.obj.channelName)!=-1){
                    this.project.customerChannel = element.code;//渠道
                }
            });
            this.project.projectName = rd.obj.projectName+   (rd.obj.matchedWords || '');//需求名称  项目名+关键字

        },


        //选择需求分类
        changeClueType(type){
            if( type=='货物类'){
             //   this.project.probjectSorts ='sd';
                this.xmOrhw = 'hw';
            }

            if( type.indexOf("工程类") != -1){
              //  this.project.probjectSorts ='xm';
                this.xmOrhw = 'xm';
            }
        },

        showComList(value) {
            ss.netApi.selectByUserNameLoud(value).then(res => {
                console.log(res)
                this.agentList = res.obj
                this.project.agentCode = res.obj[0].usercode
            })
        },
        //查询一级分类
        selectOne() {
            ss.ProService.product1Select().then(rd => {
                this.oneList = rd;
            })
        },
        selectTwo(name) {
            this.project.products[0].proModel='';
            this.project.products[0].proCode='';
            this.project.products[0].proLevelTwo='';
            let one = _.find(this.oneList,{levelname:name});
            console.log('ASDASD',one);

            //查询二级分类
            ss.ProductLevel.selectTwo(one.id).then(rd => {
                this.twoList = rd;
            });
            //查询产品
            ss.ProService.product2NoOemSelect(one.id).then(rd => {
                this.productList = rd;
            })
        },

        //查询用户单位
        showGroupClueList(value) {
            ss.MuBiao.getUserLoud(value).then(res => {
                this.customerNameList = res
                this.add.userUnitCode = res[0].id
            })
        },

        //根据型号查询大类
        selectLevelByModel(promodel) {
            if(promodel){
                //查询二级分类
                ss.ProductLevel.selectLevelByModel(promodel).then(rd => {
                    this.project.products[0].proLevelOne = rd.obj.oneName;
                    this.project.products[0].proLevelTwo = rd.obj.twoName;
                    this.project.products[0].proCode = rd.obj.proCode;
                });
            }else{
                this.project.products[0].proCode = '';
            }

        },

        backL() {

            if(this.project.fromSource =='RTB_91' || this.project.fromSource =='RTB_93'){
                this.$router.push({ path: "/bscClueTabs", query: { type: "second"} });
            }
            if(this.project.fromSource =='PP_01' || this.project.fromSource =='PP_02'){
                this.$router.push({ path: "/bscClueTabs", query: { type: "third"} });
            }
            if(this.project.fromSource =='MC_03' ){
                this.$router.push({ path: "/bscClueTabs", query: { type: "fourth"} });
            }
            if(this.project.fromSource =='CH_01' ){
                this.$router.push({ path: "/bscClueTabs", query: { type: "fifth"} });
            }
            if(this.project.fromSource =="MC_03_400"){
                this.$router.push({ path: '/bsccluemanage' })
            }

        },
        //提交
        commitCreate(){

            this.$refs['addForm'].validate((valid1) => {
                if (valid1) {
                    this.$msg.confirm("确认提交？",()=>{

                        if(this.project.fromSource =="MC_03_400"){
                            if(!this.project.estimatedAmount){
                                this.$msg.msge("400线索来源请填写预估金额");
                                return;
                            }
                        }


                        //货物类转项目，产品大类，产品中类，产品型号必填其中一
                        if(this.xmOrhw=='hw'){
                            if(!this.project.products[0].proLevelOne && !this.project.products[0].proLevelTwo && !this.project.products[0].proModel ){
                                this.$msg.msge("货物类转项目,产品大类，产品中类，产品型号必填其中一!");
                                return;
                            }
                        }
                        //项目类转项目时，项目负责人为必填项
                        if(this.xmOrhw=='xm'){
                            if(!this.project.projectLeaderCode){
                                this.$msg.msge("请填写项目负责人");
                                return;
                            }
                        }

                        ss.BscClueZhaoBiao.clueToProject(this.project).then(res => {
                            console.log(res)
                            if (res.f == true) {
                                this.$message({
                                    type: 'success',
                                    message: '保存成功!'
                                });
                                this.backL();
                            } else {
                                this.$message.error(res.msg);
                            }
                        })


                    })
                }else{
                    this.$msg.msge("请完善基本信息后提交");
                    return;
                }

            });



        },

        //检查用户是否存在
        getUser(name){

            let username ={"username":name};

            ss.UserService.selectByName(username).then(rd => {
                console.log("rd",rd.obj==null)
                if(rd.obj==null || rd.obj.length==0){
                    this.project.projectLeaderCode ='';
                    this.project.projectLeaderName ='';
                }else{
                    this.groupLeader = rd.obj;

                }
            })
        },

        setUser(value){
            this.project.projectLeaderName = _.find(this.groupLeader, {usercode: value}).username;

            console.log("code", this.project.projectLeaderCode)
            console.log("name", this.project.projectLeaderName)
        },
    },

}
</script>
<style scoped lang="scss">
.y-container {
    width: 100%;

    .y_tabBar {
        display: flex;
        justify-content: flex-start;
        flex-wrap: nowrap;

        .eveBar {
            padding: 0.1rem 0.1rem 0.1rem 0.1rem;
            width: 1.85rem;
            height: 0.73rem;
            border: 1px solid #d9dfe9;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 0.16rem;
            position: relative;
            cursor: pointer;
            font-size: 0.18rem;
            color: #525252;

            &:last-child {
                margin-right: 0;
            }

            .imgrigt {
                margin-left: 0.08rem;
            }
        }

        .eveBarAc {
            background-color: #248bff;
            color: white;
        }

        .redCircle {
            width: 0.15rem;
            height: 0.15rem;
            background-color: #e64a19;
            position: absolute;
            top: -0.06rem;
            right: -0.06rem;
            border-radius: 50%;
        }
    }

    .containGrey {
        width: 100%;
        border: 1px solid #dedede;
        background-color: #f9f9f9;
        margin-top: 0.4rem;

        .containAll {
            padding: 0.3rem;
            max-height: 3.6rem;
            width: 100%;
            overflow-y: auto;
        }

        .dialogDiv {
            margin-bottom: 0.2rem;

            .timeTip {
                color: #999999;
                font-size: 0.14rem;
                width: 100%;
                text-align: center;
                margin-bottom: 0.18rem;
            }

            .firstTalk {
                display: flex;

                .leftname {
                    font-size: 0.18rem;
                    color: #2a2a2a;
                }

                .containTalk {
                    font-size: 0.16rem;
                    color: #5e5e5e;
                    border: 1px solid #dedede;
                    background-color: white;
                    width: 7.1rem;
                    border-radius: 5px;
                    margin-left: 0.3rem;
                    padding: 0.2rem;
                    word-break: break-word;
                }

                .containTalk2 {
                    background-color: #e8e7e7;
                    margin-right: 0.3rem;
                    word-break: break-word;
                }
            }

            .firstTalk2 {
                flex-direction: row-reverse;
            }
        }

        .replyBox {
            padding: 0.2rem;
            border-top: 1px solid #dedede;
            display: flex;
            background-color: white;

            .tips {
                font-size: 0.18rem;
                color: #0072ed;
                flex-shrink: 0;
                margin-right: 0.15rem;
            }

            .replyBar {
                position: relative;
                width: 100%;

                .relpyInput {
                    width: 100%;
                    height: 0.72rem;
                    border: none;
                    background-color: #FFFFFF;
                    outline: none;
                    padding: 0.08rem;
                    padding-top: 0.04rem;
                    resize: none;
                }

                .h-bgblueQ2 {
                    background-color: #2785e7;
                    color: white;
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    height: 0.46rem;
                    width: 1.1rem;
                    padding: 0;
                }
            }
        }
    }

}
.red-border-wrapper {
    border: 2px solid #ed5736;  /* 边框颜色为红色，宽度为2px */
    padding: 10px 10px 0px 10px; /* 上、右、下、左内边距分别为10px、10px、5px、10px */
    border-radius: 8px;     /* 边框圆角为8px */
    margin-bottom: 20px;    /* 下边距为20px */
}

.loopClosed {
    width: 100%;
    display: flex;
    padding-bottom: 50px;
}

.loopClosed .loop {
    width: 30%;
    margin-left: 3%;
}

.loopClosed .loop:first-child {
    margin: 0;
}

.loopClosed .loop .title {
    font-size: 0.18rem;
    color: #0e75e9;
    font-weight: bold;
    border-left: 0.05rem solid #0e75e9;
    margin-bottom: 0.3rem;
    padding-left: 10px;
}

.loopClosed .loop .boxs {
    width: 100%;
    padding: 60px;
    box-sizing: border-box;
    border: 1px solid #e4e4e4;
    color: #868686;
    font-size: 0.16rem;
    margin-bottom: 0.3rem;
    border-radius: 3px;
}

.shenglue {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}

.loopClosed .loop .buttons {
    width: 145px;
    height: 55px;
    border: 1px solid #e4e4e4;
    border-radius: 3px;
    color: #323232;
    font-size: 0.16rem;
    text-align: center;
    line-height: 55px;
    margin-left: 50%;
    transform: translateX(-72px);
    cursor: pointer;
}
</style>
<style>

.weekplandetail35 .h-formbLine .el-form-item__label {
    width: 31%;
    text-align: right;
}

.weekplandetail35 .h-formbLine .el-form-item__content {
    width: 69%;
}

.weekplandetail35 .h-formbLine .h-elformWrap-2 {
    width: 33.333%;
    padding-right: 0.5rem
}
.weekplandetail35 .h-formbLine .h-elformWrap-6 {
    width: 100%;
    padding-right: 0.5rem
}

.weekplandetail35 .h-formbLine .h-elformWrap-1 {
    width: 100%;
    padding-right: 0.5rem
}

.weekplandetail35 .h-formbLine .h-elformWrap-1 .el-form-item__label {
    width: 9.7%;
}

.weekplandetail35 .h-formbLine .h-elformWrap-1 .el-form-item__content {
    width: 90.3%;
}
</style>
<style scoped lang="scss">
.bottomTip{
    position: absolute;
    left: 49.7%;
    bottom: 0.3rem;
    transform: translateX(-50%);
    z-index: 999999;
}
.newtext{
    font-size: 0.28rem;
    color: white;
    position: absolute;
    top:0.2rem;
    left: 50%;
    transform: translateX(-50%);
    font-weight: bold;
    text-shadow:1px 1px 4px #2785E7;
    z-index: 2;
}
.leaderBox{
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.4);
    position: fixed;
    z-index: 99999;
    overflow: hidden;
    top: 0;
    left: 0;
    .leaderbg{
        width: 100%;
        height: 100%;
    }
    .steps{
        position: absolute;
        z-index: 1;
    }
    .step1{
        top: 0;
        left: 0;
    }

    .stepbtn{
        width: 1.9rem;
        height: 0.6rem;
        border: 0.03rem solid #FFFFFF;
        background-color: rgba(0,0,0,0.1);
        border-radius: 5px;
        display: flex;
        justify-content: center;
        line-height: 0.5rem;
        position: absolute;
        z-index: 99;
        bottom: 0.65rem;
        left: 50%;
        transform: translateX(-50%);
        font-size: 0.27rem;
        letter-spacing: 2px;
        color: white;
        cursor: pointer;
    }
    .closeIt{
        width: 0.3rem;
        height: 0.3rem;
        position: absolute;
        top: 0.2rem;
        right: 0.2rem;
        cursor: pointer;
        z-index: 2;
    }
    .el-textarea__inner{
        height: 26px;
        overflow-y: auto;
        /* overflow-y: auto;兼容ie  */
    }

}

/* 独立红星样式（不触发校验） */
.required-star::before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
}

::v-deep .el-input.is-disabled .el-input__inner {
    background-color: #edf0f5;

}

</style>

